// This is where we set up the custom colors for the maps

let opacity = '0.4';

const GOVERNOR = [
  {
    name: 'Greg Abbott',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: "Beto O'Rourke",
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Mark Tippetts',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
  {
    name: 'Delilah Barrios',
    color: '#3cc687',
    lean_color: '#92e8c1',
    rgbaColor: 'rgba(60, 198, 135,' + opacity + ')',
  },
];

const AG = [
  {
    name: 'Ken Paxton',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: 'Rochelle Garza',
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Mark Ash',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
];

const OTHER = '#888888';

const REPUBLICAN = '#EF564A'
const DEMOCRAT = '#1755c5'
const DEMOCRAT_LEAN = '#6DACD3'
const REPUBLICAN_LEAN = '#F6A79D';

const NEUTRAL = '#F2F2F2';
const TIE = '#8264B0';

export { GOVERNOR, AG, NEUTRAL, TIE, OTHER, REPUBLICAN, DEMOCRAT, DEMOCRAT_LEAN, REPUBLICAN_LEAN };
